// CLASSES
import AppConfig from "@classes/AppConfig";

export default function(props, state)
{
    if (AppConfig.get("developmentOptions").ignoreFullfillment === true)
    {
        return true;
    }

    const {fields} = state;

    if (fields.insurances.length === 0)
    {
        return false;
    }

    if (fields.selectedInsurance === null)
    {
        return false;
    }

    if (!fields.futur_withdrawal_type.checked)
    {
        if (fields.futur_withdrawal_amount.length <= 0)
        {
            return false;
        }

        if (fields.futur_withdrawal_amount < fields.selectedInsurance.minimumAmount||
            fields.futur_withdrawal_amount > fields.selectedInsurance.maximumAmount) {
            return false;
        }
    }

    return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/Withdrawal/AmountChooser.fulfillment.js